// noinspection JSUnusedGlobalSymbols

/**
 * File upload helper
 */
export default class FeFileUpload 
{
  /**
   * Open file picker dialog
   * @param id The id of the file input element
   */
  openFilePicker(id: string)
  {
    const element = document.getElementById(id) as HTMLInputElement;

    if (!element) {
      return;
    }

    try {
      // only supported starting with Safari 16.4+
      // // checking for user activation because browsers won't execute showPicker() without it
      // if (!navigator.userActivation.isActive)
      // {
      //     return;
      // }

      // more reliable than click() and works in Safari
      element.showPicker();
    } catch (error) {
      // fallback
      element.click();
    }
  }
}